<template>
  <a-progress 
			type="circle"
			:percent="timeLeft * 100 / timeInSeconds"
			:format="_ => `${minutes}:${zeroFilledSeconds}`"
			:stroke-color="color" />
</template>

<script>
import Vue from 'vue';
import {Progress} from 'ant-design-vue'

Vue.use(Progress);

export default {
  props: {
    timeInSeconds: Number,
    isTimedOut: Function
  },
  mounted: function () {
    this.minutes = Math.ceil(this.timeInSeconds / 60)
    this.seconds = this.timeInSeconds < 60? this.timeInSeconds: 60
    this.startTimer()
  },
  beforeDestroy: function () {
    this.stopTimer()
  },
  data() {
    return {
			timePassed: 0,
			timerInterval: null,
			minutes : 0,
			seconds: 0,
			color: "#87d068",
    }
  },
  computed: {
    timeLeft() {
			return this.timeInSeconds - this.timePassed
    },
		zeroFilledSeconds() {
			if (this.seconds < 10) {
				return '0' + this.seconds
			}
			return this.seconds
		}
  },
  methods: {
    updateStatus() {
      if (this.timePassed === this.timeInSeconds)
        this.isTimedOut()
    },
    startTimer() {
			this.minutes--
			this.timerInterval = setInterval(
				() => {
					this.seconds--
					this.timePassed++
					this.setMinutes();
					this.setColor();
					this.updateStatus();
				}, 1000
			);
		},
		setMinutes(){
			if(this.seconds == 0) {
				this.minutes--
				this.seconds = 60

				if (this.minutes == 0) {
					this.minutes = 0;
				}
			}
		},
    setColor(){
			if (this.timePassed === 80) {
				this.color = "#ffcc00"
			}
			if (this.timePassed === 110) {
				this.color = "#ff0000"
			}
		},
    stopTimer(){
			clearInterval(this.timerInterval);
		},
  }
}
</script>

<style>

</style>